import {
  SYSAction,
  unsafeHTML,
} from "../../../../../../../../../_ovlclient/src"
import {
  HookFieldGetList_Type,
  HookFormAdd_Type,
  HookFormAfterCancel_Type,
  HookFormBeforeCancel_ReturnType,
  HookFormBeforeCancel_Type,
  HookFormChanged_Type,
  HookFormValidate_Type,
  HookTableBeforeDelete_ReturnType,
  HookTableBeforeDelete_Type,
  HookTableBeforeSave_ReturnType,
  HookTableBeforeSave_Type,
  HookTableGroupCalcValue_ReturnType,
  HookTableGroupCalcValue_Type,
  HookTableGroupHeadersFooters_Type,
  HookTablePrepareFn_ReturnType,
  HookTablePrepareFn_Type,
} from "../../../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldForceChange,
  FieldIsValid,
  FieldIsValidSelective,
  FieldSetVal,
  FieldVal,
  FieldValidate,
  SYSFormState,
} from "../../../../../../../../../_ovlclient/src/library/forms/fieldapi"
import { ProcessIsRunning } from "../../../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import {
  TableGet,
  TableGetTotalResult,
} from "../../../../../../../../../_ovlclient/src/library/table/tableapi"
import { N, T } from "../../../../../../../../../_ovlclient/src/textapi"
import { OfferingPos } from "./tabledef"

import { hooks as adminuploadHooks } from "../../adminupload/hookactions"

const HookFormValidate: SYSAction<HookFormValidate_Type<OfferingPos>> = (
  value,
  { global }
) => {
  if (value.fieldKey === "U_PosGroupDesc") {
    value.validatorUse("MaxLength", { val: 10 })
  }
}

const HookFormChanged: SYSAction<HookFormChanged_Type<OfferingPos>> = (
  value,
  { global }
) => {
  let globalOfferingState = global.getState().app.global.QUT.offering
  let changedField = value.changedField
  if (changedField.isValid) {
    if (
      changedField.fieldKey === "U_Height" ||
      changedField.fieldKey === "U_Width"
    ) {
      if (
        value.validatorUse("IntegerRange", {
          val: { min: 30, max: 400 },
        })
      ) {
        let width = FieldVal(value.fields.U_Width)
        let height = FieldVal(value.fields.U_Height)
        if (width && height) {
          // for our comparison against "Sägediagramm von A. Gredig"
          // we need width be the bigger value
          if (height > width) {
            var tmp = width
            width = height
            height = tmp
          }
          let y = interpolateValue(width)
          if (y === null || height > y) {
            value.validationsAdd("QUTOfferingPosDimensionTooBig", {
              fields: [value.fields.U_Width, value.fields.U_Height],
              resetContext: "Validate",
            })
          }
        }
      }
    } else if (changedField.fieldKey === "U_Quantity") {
      value.validatorUse("IntegerRange", {
        val: { min: 1, max: 9999999 },
      })
    } else if (changedField.fieldKey === "U_Length") {
      value.validatorUse("IntegerRange", {
        val: {
          min: 100,
          max:
            13000 -
            1 -
            globalOfferingState.offeringInitialCutSize -
            globalOfferingState.offeringSawCutSize,
        },
      })
    } else if (changedField.fieldKey === "U_PosId") {
      // check for uniqueness
      let tb = TableGet<OfferingPos>(value.formState.tableDefId)
      let unique = true
      let posIdToCheck = value.changedField.newValue

      tb.getKeys()
        .filter((k) => k !== value.formState.tableRowKey)
        .forEach((k, i) => {
          let formState = tb.formStateGetForRowKey(k, {
            onlyIfInEditMode: true,
          })
          if (formState) {
            if (FieldVal(formState.fields["U_PosId"]) === posIdToCheck) {
              unique = false
              value.validationsAdd("QUTOfferingPosValidatorPosIdUnique", {
                fields: [formState.fields["U_PosId"]],
              })
            } else {
              value.validationsRemove(
                formState.fields["U_PosId"],
                "QUTOfferingPosValidatorPosIdUnique"
              )
            }
          } else {
            // its a row not in edit mode. we need also to compare those
            if (tb.rows[k].U_PosId === posIdToCheck) {
              unique = false
            }
          }
        })
      if (!unique) {
        value.validationsAdd("QUTOfferingPosValidatorPosIdUnique")
      }
    }
  }
}

// according sägediagramm säge 700mm
const maxCutPoints = [
  { x: 30, y: 220 },
  { x: 50, y: 235 },
  { x: 100, y: 240 },
  { x: 200, y: 230 },
  { x: 300, y: 225 },
  { x: 320, y: 220 },
  { x: 350, y: 200 },
  { x: 400, y: 170 },
  { x: 450, y: 40 },
]

const interpolateValue = (xValue) => {
  // Find the interval xValue is in
  for (let i = 0; i < maxCutPoints.length - 1; i++) {
    const x0 = maxCutPoints[i].x
    const x1 = maxCutPoints[i + 1].x
    const y0 = maxCutPoints[i].y
    const y1 = maxCutPoints[i + 1].y
    if (xValue >= x0 && xValue <= x1) {
      return y0 + ((y1 - y0) * (xValue - x0)) / (x1 - x0)
    }
  }
  return null
}

const HookFormAfterCancel: SYSAction<HookFormAfterCancel_Type> = async (
  value,
  { global }
) => {
  let posField = value.formState.fields.U_PosId
  if (!FieldIsValid(posField)) {
    await FieldSetVal(posField, -9999)
  }
}

const HookFormAdd: SYSAction<HookFormAdd_Type<OfferingPos>> = (
  value,
  { global }
) => {
  let tb = TableGet<OfferingPos>(value.tableDef.id)
  let sort = tb.def.uiState.sort.sort
  // //get max Pos Nr
  // let max = Math.max(...Object.keys(tb.rows).map((o) => tb.rows[o].U_PosId))
  // if (max === -Infinity) {
  //   max = 1
  // } else {
  //   max++
  // }
  if (sort.field === "U_PosId" && sort.direction === "asc") {
    value.newRow.U_PosId = 1
    // other values from previous row
    // plus use the increment between last 2 pos for new posid
    if (tb.def.uiState.rowsCount > 0) {
      let keys = tb.getKeys()
      let lastRow: OfferingPos = tb.rows[keys[keys.length - 1]]
      value.newRow.U_PosId = lastRow.U_PosId + 1
      value.newRow.U_Height = lastRow.U_Height
      value.newRow.U_Width = lastRow.U_Width
      value.newRow.U_PosGroupDesc = lastRow.U_PosGroupDesc
      value.newRow.U_SKL = lastRow.U_SKL
      value.newRow.U_Length = lastRow.U_Length
      if (keys.length > 1) {
        let lastlastRow: OfferingPos = tb.rows[keys[keys.length - 2]]
        value.newRow.U_PosId =
          lastRow.U_PosId + (lastRow.U_PosId - lastlastRow.U_PosId)
      }
    }
  }
}

const HookField_U_SKL_GetList: SYSAction<HookFieldGetList_Type> = (
  value,
  { global }
) => {
  return global.getState().app.global.QUT.lookups.U_ImportSKL
}

const HookTableGroup_m3_CalcValue: SYSAction<
  HookTableGroupCalcValue_Type<OfferingPos>,
  HookTableGroupCalcValue_ReturnType
> = (value, { global }) => {
  return (
    (((((value.row.U_Quantity * value.row.U_Height) / 1000) *
      value.row.U_Width) /
      1000) *
      value.row.U_Length) /
    1000
  )
}

const HookTableGroupFooters: SYSAction<
  HookTableGroupHeadersFooters_Type<OfferingPos>
> = (value, { global }) => {
  var template = value.getTemplate("columns")
  let colToSet = template.valueToSet[value.grouping.visibleColumns[1]]
  colToSet.value = unsafeHTML(
    T("QUTOfferingPosTotalStk", N(TableGetTotalResult("stk").Sum))
  )
  value.results.push(template)
  template = value.getTemplate("columns")
  colToSet = template.valueToSet[value.grouping.visibleColumns[1]]
  colToSet.value = unsafeHTML(
    T("QUTOfferingPosTotalM3", N(TableGetTotalResult("m3").Sum))
  )
  value.results.push(template)
}

const HookTableGroup_stk_CalcValue: SYSAction<
  HookTableGroupCalcValue_Type<OfferingPos>,
  HookTableGroupCalcValue_ReturnType
> = (value, { global }) => {
  return value.row.U_Quantity
}

const HookTablePrepareFn: SYSAction<
  HookTablePrepareFn_Type,
  HookTablePrepareFn_ReturnType
> = (value, { global }) => {
  if (ProcessIsRunning("GENRefreshData")) {
    return { SYSAdd: { visibility: "Disabled" } }
  }
}

const HookTableBeforeSave: SYSAction<
  HookTableBeforeSave_Type,
  HookTableBeforeSave_ReturnType
> = (value, { global }) => {
  if (value.hasChanges) {
    global.getState().app.features.QUTOffering.cutListDirty = true
  }

  if (value.originalRow["U_DocEntry"] === -1) {
    return { resolve: "SaveLocally" }
  }
}

const HookTableBeforeDelete: SYSAction<
  HookTableBeforeDelete_Type,
  HookTableBeforeDelete_ReturnType
> = (value, { global }) => {
  global.getState().app.features.QUTOffering.cutListDirty = true
  if (value.row["U_DocEntry"] === -1) {
    return { resolve: "DeleteLocally" }
  }
}

export let hooks = {
  HookFormChanged,
  HookFormValidate,
  HookFormAdd,
  HookField_U_SKL_GetList,
  HookTableGroup_m3_CalcValue,
  HookTableGroup_stk_CalcValue,
  HookTableGroupFooters,
  HookTablePrepareFn,
  HookTableBeforeDelete,
  HookTableBeforeSave,
  HookField_CntctCode_GetList: adminuploadHooks.HookField_CntctCode_GetList,
  HookLookupsRefresh: adminuploadHooks.HookLookupsRefresh,
  HookFormAfterCancel,
}
